<template>
  <v-container id="payemtlogs" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-date-picker
                    class="purple-input"
                    :label="$i18n.t('From Date')"
                    v-model="filters.logFrom"
                    timestamp
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-time-picker
                    :label="$i18n.t('From Time')"
                    class="purple-input"
                    v-model="filters.logFrom"
                    timestamp="filters.logFrom"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-date-picker
                    class="purple-input"
                    :label="$i18n.t('Till Date')"
                    v-model="filters.logTill"
                    timestamp
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-time-picker
                    :label="$i18n.t('Till Time')"
                    class="purple-input"
                    v-model="filters.logTill"
                    timestamp="filters.logTill"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-text-field
                    v-model="filters.amountFrom"
                    :label="$i18n.t('Amount Range')"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-text-field
                    v-model="filters.amountTill"
                    :label="$i18n.t('Amount Range')"
                    type="number"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-select
                    :label="$i18n.t('Payment Status')"
                    :items="statusList"
                    item-text="name"
                    item-value="value"
                    v-model="filters.status"
                    clearable
                  />
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-currency-select v-model="filters.currency" />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn color="blue lighten-1" fab small class="mr-0" @click="search(true)">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Payment Transaction')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" md="2" lg="2">{{ $i18n.t("Client")}}</v-col>
                <v-col cols="12" md="2" lg="2">{{ $i18n.t("User")}}</v-col>
                <v-col cols="12" md="2" lg="2">{{ $i18n.t("Created At")}}</v-col>
                <v-col cols="12" md="1" lg="1">{{ $i18n.t("Amount")}}</v-col>
                <v-col cols="12" md="2" lg="2">{{ $i18n.t("Trans Detail") }}</v-col>
                <v-col cols="12" md="1" lg="1">{{ $i18n.t("Gateway") }}</v-col>
                <v-col cols="12" md="1" lg="1">{{ $i18n.t("Status") }}</v-col>
                <v-col cols="12" md="1" lg="1">{{ $i18n.t("Purpose") }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-virtual-scroll
        :bench="5"
        :items="grid.rows"
        :height="gridHeight"
        :item-height="itemHeight"
      >
        <template v-slot="{item}">
          <v-row>
            <v-col cols="12" xs="11" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">
                  {{item.corporateName}}
                  <br />
                  {{item.merchantName}}
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">
                  {{item.userName}}
                  <br />
                  {{item.userPhone}}
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="body-2"
                >{{item.createdAt | moment("DD MMM YYYY hh:mm a")}}</v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="1"
                  lg="1"
                  class="body-2"
                >{{item.currency + " " + item.amount}}</v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">
                  {{item.txn_mode}}
                  <br />
                  {{item.txn_id}}
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{item.gateway}}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{item.statusStr}}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{item.purpose}}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-virtual-scroll>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "PaymentLogs",
})
export default class Bills extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/payment/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  statusList = [
    { value: 0, name: "Created" },
    { value: 1, name: "Initiated" },
    { value: 2, name: "Success" },
    { value: 3, name: "Failed" },
    { value: 4, name: "Refund Initiated" },
    { value: 5, name: "Refund Completed" },
    { value: 6, name: "Paid from Wallet" },
    { value: 7, name: "Partial paid by Wallet rest by Cash" },
    { value: 8, name: "Others" },
    { value: 9, name: "Paid by Wallet and Cash" },
    { value: 10, name: "Refund to Wallet" },
    { value: 11, name: "Paid from Gift Voucher" },
    { value: 12, name: "Partially paid from Gift Voucher" },
    { value: 13, name: "Paid by Gift Voucher and Cash" },
  ];

  filters = {
    logFrom: null,
    logTill: null,
    amountFrom: null,
    amountTill: null,
    status: null,
    currency: null,
  };

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    this.showPage(1);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search(download) {
    this.filterUrl = "";
    let url = "";
    if (this.filters.logFrom) url += "&startTimeFrom=" + this.filters.logFrom;
    if (this.filters.logTill) url += "&startTimeTo=" + this.filters.logTill;
    if (this.filters.currency) url += "&currency=" + this.filters.currency;
    if (this.filters.status) url += "&status=" + this.filters.status;
    if (this.filters.amountFrom)
      url += "&amountFrom=" + this.filters.amountFrom;
    if (this.filters.amountTill)
      url += "&amountTill=" + this.filters.amountTill;
    if (download) {
      window.open("/api/payment/transaction/download?" + url, "_blank");
    } else {
      this.filterUrl = url;
      await this.showPage(1);
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
